import type { ActivityEntry } from '../ActivityChapter.interface';
import Layout from './Layout';
import MainText from './MainText';
import ListItem from './ListItem';
import SectionQr from '../../SevicesMenu/components/SectionQr';
import { GradualSpacing } from '../../../effects/GradualSpacing';
import { motion } from 'framer-motion';
import FooterQr from './FooterQr';
import { DEFAULT_CAROUSEL_ITEM_DURATION_S } from '../ActivityChapter.constants';

export default function Activity({ entry }: { entry: ActivityEntry }) {

    return (
        <>
            <Layout
                entry={entry}
                media={entry.media?.[0]}
            >
                <motion.div
                    initial={{
                        opacity: 1,
                    }}
                    animate={{
                        opacity: entry.has_qr_code ? 0 : 1,
                    }}
                    transition={{
                        delay: DEFAULT_CAROUSEL_ITEM_DURATION_S,
                    }}
                >
                    <MainText
                        offset={.3}
                        content={entry.title}
                    >
                        <div
                            style={{
                                position: 'relative',
                                fontSize: '2.86vh', // 55
                                lineHeight: '2.6vh', // 50px
                                fontWeight: 400,
                            }}
                        >
                            <GradualSpacing offset={.3} text={entry.subtitle} />
                        </div>
                    </MainText>
                </motion.div>

                <motion.div
                    style={{
                        position: 'absolute',
                        top: '61.72vh', // 1185
                        bottom: '2.6vh', // 50
                        right: '2.6vh', // 50
                        minWidth: '50%',
                        maxWidth: '70vw',
                        maxHeight: '70vh',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4.17vh', // 80
                    }}
                    initial={{
                        opacity: 1,
                    }}
                    animate={{
                        opacity: entry.has_qr_code ? 0 : 1,
                    }}
                    transition={{
                        delay: DEFAULT_CAROUSEL_ITEM_DURATION_S,
                    }}
                >
                    <ListItem
                        offset={.4}
                        size={'normal'}
                        title={entry.pillar}
                        details={entry.details}
                    />
                </motion.div>

                {entry?.has_qr_code && entry?.qr_code?.variant !== 'corner' ? (
                    <SectionQr
                        scrim={false}
                        media={entry?.qr_code?.media}
                        title={entry?.qr_code?.title}
                        subtitle={entry?.qr_code?.subtitle}
                        delay={DEFAULT_CAROUSEL_ITEM_DURATION_S}
                    />
                ) : null}

                {entry?.has_qr_code && entry?.qr_code?.variant === 'corner' ? (
                    <FooterQr
                        media={entry?.qr_code?.media}
                        logo={entry?.qr_code?.logo}
                        title={entry?.qr_code?.title}
                    />
                ) : null}
            </Layout>
        </>
    );
}
